import { CombineSurveyTrafficReportParams } from '@ps/survey-utils';
import { BasePayloadMapper } from '@ps/utils';

import { CombinedSTReportPayloadDto } from '../../dtos/reports.dto';

export class CombinedSTPayloadMapper extends BasePayloadMapper<
  CombineSurveyTrafficReportParams,
  CombinedSTReportPayloadDto
> {
  public override toPayload(
    from: CombineSurveyTrafficReportParams,
  ): CombinedSTReportPayloadDto {
    return {
      user_id: from.cmp.toString(),
      survey_id: from.surveys.map((survey) => survey.id).join(','),
      st: from.statuses.join(','),
      includeTestTransactions: String(from.includeTestTransactions),
      type: from.userType,
    };
  }
}
